module.exports = __webpack_public_path__ + "img/Photo-N1.3fefea46.gif";